var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container-location-item'],style:(_vm.style),on:{"click":function($event){return _vm.navigationToSchedule()}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("favorite_border")]),_c('p',{staticClass:"title-item"},[_vm._v(_vm._s(_vm.program.attraction.name))]),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("arrow_forward")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }